/**
 * Section 08 — Reviews / UGC
 * Swiper init/destroy at 1200px breakpoint
 */
(function () {
  'use strict';

  const BREAKPOINT = 1200;
  let swiperInstance = null;

  function initSwiper() {
    if (swiperInstance) return; // already running

    const el = document.querySelector('.acc103-08__swiper');
    if (!el) return;

    import('https://cdn.jsdelivr.net/npm/swiper@12/swiper-bundle.min.mjs').then(({ default: Swiper }) => {
      swiperInstance = new Swiper(el, {
        loop: false,
        initialSlide: 0,
        slidesPerView: 1.2,
        spaceBetween: 12,
        centeredSlides: true,
        grabCursor: true,
        pagination: {
          el: el.querySelector('.swiper-pagination'),
          clickable: true,
        },
        a11y: {
          enabled: true,
          prevSlideMessage: 'Previous review',
          nextSlideMessage: 'Next review',
        },
        breakpoints: {
          600: {
            slidesPerView: 1.15,
            spaceBetween: 16,
            centeredSlides: true,
          },
          900: {
            slidesPerView: 1.6,
            spaceBetween: 20,
            centeredSlides: true,
          },
        },
      });
    });
  }

  function destroySwiper() {
    if (!swiperInstance) return;
    swiperInstance.destroy(true, true);
    swiperInstance = null;
  }

  function handleResize() {
    if (window.innerWidth < BREAKPOINT) {
      initSwiper();
    } else {
      destroySwiper();
    }
  }

  // On DOM ready
  document.addEventListener('DOMContentLoaded', function () {
    handleResize();

    let resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(handleResize, 150);
    });
  });
})();
